import escapeRegExp from "lodash/escapeRegExp";

const ignoredErrorMessages = [
	"ResizeObserver loop limit exceeded",
	"Request failed with status code 401",
	"Could not mount master component",
	"Refresh token is failing with error Error: Login required",
	"REPLY_TIMEOUT",
	"Couldn't find your IP",
	'You are publicly sharing your App Secret. Do not expose the App Secret in browsers, "native" mobile apps, or other non-trusted environments.',
	"ChunkLoadError",
	"Collect JS Token is empty",
	"Loading CSS chunk",
	"[object ProgressEvent]",
	"Cannot read properties of undefined (reading 'is')",
	'{"cors":"rejected"}',
	"Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
	"Tiny mce subject editor not ready",
	"Token expired",
	"Please provide a feed slug and user id, ie client.feed('user', '1')",
	"cb-master-frame iframe load failed",
	"Action timed out",
	"DataCloneError",
	"The following deprecated features are currently enabled, these will be removed in TinyMCE 6.0",
	"The element or ID supplied is not valid",
	"Error during service worker registration",
	"Worker was terminated",
	"Failed to load plugin",
	"Failed to fetch",
	"Login required",
	"ETIMEDOUT",
	"Cannot read properties of undefined (reading 'logEvent')",
	"[object CustomEvent]"
];

export const errors: RegExp[] = ignoredErrorMessages.map(
	ignoredMessage => new RegExp(escapeRegExp(ignoredMessage), "i")
);

const matchesIgnoredError = (text?: string): boolean =>
	text !== undefined && errors.some(pattern => pattern.test(text));

const shouldSentryLogMessage = (message?: string, extra?: string): boolean =>
	!matchesIgnoredError(message) && !matchesIgnoredError(extra);

export default shouldSentryLogMessage;
